// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"oW","selections":"pW","pillsDesktopSearchMenu":"qW"};